import { useContext, useEffect, useState } from 'react';

import BarraInferiorBotoes from '../../../../../components/BarraInferiorBotoes';
import BoxConteudo from '../../../../../components/BoxConteudo';
import CustomButton from '../../../../../components/CustomButton';
import CustomCol from '../../../../../components/CustomCol';
import { CustomSwal } from '../../../../../components/CustomFeedback/CustomSwal';
import { useToast } from '../../../../../components/CustomFeedback/CustomToast';
import CustomInputText from '../../../../../components/CustomInputs/CustomInputText';
import CustomModal from '../../../../../components/CustomModal';
import CustomRow from '../../../../../components/CustomRow';
import SelectSearchable from '../../../../../components/CustomSelectSearchable';
import CustomSelect from '../../../../../components/CustomSelects/CustomSelect';
import CustomSelectSearchable from '../../../../../components/CustomSelects/CustomSelectSearchable';
import CustomTable from '../../../../../components/CustomTable';
import { TableRow } from '../../../../../components/CustomTable/types/table.type';
import Log from '../../../../../components/Log/Log';
import WorkspaceBotoes from '../../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../../components/WorkspaceFicha';
import { UserContext } from '../../../../../modules/contexts/Auth/UserProvider';
import { getFinalidadeDocumentoMedsusLabel } from '../../../../../modules/types/FinalidadeDocumentoMedsus.enum';
import {
  getStatusAtivoMedsusLabel,
  getStatusAtivoMedsusOptions,
  getStatusAtivoMedsusSlug,
  StatusAtivoMedsusEnum,
} from '../../../../../modules/types/StatusAtivoMedsus.enum';
import {
  getTipoDocumentoMedsusLabel,
  TipoDocumentoMedsusEnum,
} from '../../../../../modules/types/TipoDocumentoMedsus.enum';
import { LogData } from '../../../../../modules/types/types';
import { useFinalidadeDocumentoMedsus } from '../../../../../services/enum/medsus/useFinalidadeDocumentoMedsus';
import { useSubtipoDocumentoMedsus } from '../../../../../services/enum/medsus/useSubtipoDocumentoMedsus';
import { useSubtipoExameMedsus } from '../../../../../services/enum/medsus/useSubtipoExameMedsus';
import { useTipoDocumentoMedsus } from '../../../../../services/enum/medsus/useTipoDocumentoMedsus';
import { isHttpError } from '../../../../../services/httpClient';
import {
  getAllMedsusDocumentoByDiretrizVmp,
  handleCreateMedsusDocumento,
  handleUpdateMedsusDocumento,
} from '../../../../../services/medsus/medsusDocumentoService';
import theme from '../../../../../theme';
import { ENTITY } from '../../../../../utils/entityNames';
import { sanitizarForm } from '../../../../../utils/functions';
import { handleDelete } from '../../../../../utils/handleDelete';
import { headersDocumentosMedsus } from '../auxliarProdutoMedsus';
import { INITIAL_FORM_PRODUTO_MEDSUS_DOCUMENTO } from '../utils/initialStates';
import { MedsusDocumento } from '../utils/medsusTypes';

interface DocumentoProps {
  vmpID: string;
  userID: number;
  btDisable?: boolean;
}

type InputLikeEvent = {
  target: {
    name: string;
    value: string | number;
  };
};

export function DocumentoMedsus(props: DocumentoProps) {
  const { cudProdutoDaf } = useContext(UserContext);
  const entity = ENTITY.ENTITY_Medsus_Documento;

  // Enums
  const TipoDocumento = useTipoDocumentoMedsus();
  const { optionsSubtipoDocumento, createSubtipoDocumento, reload } =
    useSubtipoDocumentoMedsus();
  const { SubtipoExame, CodigoExame } = useSubtipoExameMedsus();
  const FinalidadeDocumento = useFinalidadeDocumentoMedsus();
  // Data
  const [updating, setUpdating] = useState<boolean>(false);
  const [documentoData, setDocumentoData] = useState<MedsusDocumento[]>([]);
  const [form, setForm] = useState(
    INITIAL_FORM_PRODUTO_MEDSUS_DOCUMENTO(
      props.userID,
      Number(props.vmpID),
    ) as MedsusDocumento,
  );
  const [showModalDocumento, setShowModalDocumento] = useState<boolean>(false);

  const [logData, setLogData] = useState<LogData>();

  // Hooks
  useEffect(() => {
    if (isProtocoloCreated()) fetchData();
  }, [props.vmpID]);

  const { showToast } = useToast();
  // Data Management
  const isProtocoloCreated = (): boolean => {
    return Number(props.vmpID) !== 0;
  };

  const fetchData = async () => {
    try {
      const objetos = await getAllMedsusDocumentoByDiretrizVmp(props.vmpID);

      setDocumentoData(objetos);
    } catch (error) {
      console.error('Erro ao obter dados: ', error);
    }
  };

  const tableData: TableRow[] = documentoData?.map(
    (documento: MedsusDocumento) => ({
      id: documento.id,
      status: getStatusAtivoMedsusLabel(Number(documento.statusDocumento)),
      tipo: getTipoDocumentoMedsusLabel(Number(documento.tipoDocumento)),
      subtipo: documento.subtipoDocumento?.nome ?? documento.subtipoExame?.nome,
      finalidade: getFinalidadeDocumentoMedsusLabel(
        Number(documento.finalidade),
      ),
    }),
  );

  const offcanvasData: Array<any> = [];

  // Form Validate
  const validateForm = (form: MedsusDocumento) => {
    const errors: string[] = [];

    if (!form.statusDocumento) errors.push('<b>Status</b> é obrigatório.');

    if (!form.tipoDocumento) errors.push('<b>Tipo</b> é obrigatório.');

    if (
      Number(form.tipoDocumento) === TipoDocumentoMedsusEnum['DOCUMENTO'] &&
      !form.subtipoDocumentoId
    )
      errors.push('<b>Tipo de Documento</b> é obrigatório.');

    if (
      Number(form.tipoDocumento) === TipoDocumentoMedsusEnum['EXAME'] &&
      !form.subtipoExameId
    ) {
      errors.push('<b>Código</b> é obrigatório.');
      errors.push('<b>Tipo de Exame</b> é obrigatório.');
    }

    if (!form.finalidade) errors.push('<b>Finalidade</b> é obrigatório.');

    if (errors.length > 0) {
      CustomSwal.quick('warning', errors.join('<br>'));
      return false;
    }

    return true; // Validação bem-sucedida
  };

  const formatForm = (form: MedsusDocumento) => {
    const formAjustado = {
      ...form,
      statusDocumento: Number(form.statusDocumento),
      tipoDocumento: Number(form.tipoDocumento),
      finalidade: Number(form.finalidade),
      subtipoDocumentoId: form.subtipoDocumentoId
        ? Number(form.subtipoDocumentoId)
        : null,
      subtipoExameId: form.subtipoExameId ? Number(form.subtipoExameId) : null,
    };

    return formAjustado;
  };

  // Handle Functions
  const handleClearForm = () => {
    setForm(
      INITIAL_FORM_PRODUTO_MEDSUS_DOCUMENTO(props.userID, Number(props.vmpID)),
    );
    setLogData({
      ...logData,
      id: 0,
      usuarioRegistro: '',
      usuarioAtualizacao: '',
      dataRegistro: '',
      dataAtualizacao: '',
      nEdicoes: 0,
    });
  };

  const handleRowClick = (row: TableRow) => {
    handleShowModalDocumento();
    setUpdating(true);
    const filteredItem = documentoData?.find((item) => item.id == row.id);

    setLogData({
      id: filteredItem?.id ?? 0,
      usuarioRegistro: filteredItem?.usuarioRegistro?.nomeCompleto || '',
      usuarioAtualizacao: filteredItem?.usuarioAtualizacao?.nomeCompleto || '',
      dataRegistro: filteredItem?.dataRegistro || '',
      dataAtualizacao: filteredItem?.dataUltimaAtualizacao || '',
      nEdicoes: filteredItem?.nEdicoes || 0,
    });
    if (filteredItem) {
      setForm({
        ...form,
        id: filteredItem.id,
        finalidade: filteredItem.finalidade,
        diretrizVmp: filteredItem.diretrizVmp,
        detalhamento: filteredItem.detalhamento,
        statusDocumento: filteredItem.statusDocumento,
        subtipoDocumento: filteredItem.subtipoDocumento,
        subtipoDocumentoId: filteredItem.subtipoDocumento?.id ?? undefined,
        subtipoExame: filteredItem.subtipoExame,
        subtipoExameId: filteredItem.subtipoExame?.id ?? undefined,
        tipoDocumento: filteredItem.tipoDocumento,
        usuario: filteredItem.usuario,
        usuarioId: filteredItem.usuario?.id ?? props.userID,
        observacoes: filteredItem.observacoes,
      });
    }
  };

  const handleShowModalDocumento = () => {
    setShowModalDocumento((prev) => !prev);
    handleClearForm();
  };

  const handleChangeDocumento = (
    event:
      | React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
      | InputLikeEvent,
  ) => {
    const { name, value } = event.target;

    setForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleClickInserirNovo = () => {
    setUpdating(false);
    handleShowModalDocumento();
    handleClearForm();
  };

  // REST
  const handleCreateSubtipoDocumento = async (nomeSubtipo: string) => {
    const formNewSubtipoDoc = {
      nome: nomeSubtipo.toUpperCase(),
      status: getStatusAtivoMedsusSlug(StatusAtivoMedsusEnum['ATIVO']),
      usuarioId: props.userID,
    };
    const novaOpcao = await createSubtipoDocumento(formNewSubtipoDoc);
    if (!novaOpcao) return;
    reload();

    handleChangeDocumento({
      target: {
        name: 'subtipoDocumentoId',
        value: novaOpcao.value,
      },
    });
  };

  const handleCreateDocumento = async () => {
    try {
      if (!validateForm(form)) throw new Error('Formulário inválido');
      const formAjustado = formatForm(form);
      const formToSend = sanitizarForm(formAjustado);
      await handleCreateMedsusDocumento(formToSend);

      showToast('Registro criado com sucesso!', 'success', 5000);
      fetchData();
      setTimeout(() => handleShowModalDocumento(), 1000);
    } catch (error) {
      if (isHttpError(error)) {
        showToast(error.response?.data.message, 'error');
      }
      console.error('Erro ao salvar registro:', error);
    }
  };

  const handleUpdateDocumento = async () => {
    try {
      if (!validateForm(form)) throw new Error('Formulário inválido');

      const formAjustado = formatForm(form);
      const formToSend = sanitizarForm(formAjustado);

      const response = await handleUpdateMedsusDocumento(formToSend);

      showToast(response.message);
      fetchData();
    } catch (error: any) {
      if (isHttpError(error)) {
        showToast(error.response?.data.message, 'error');
      }
      console.error('Erro ao atualizar dados', error);
    }
  };

  const handleDeleteDocumento = async () => {
    await handleDelete(form.id, 'medsusdocumento');
    fetchData();
    handleShowModalDocumento();
  };

  return (
    <BoxConteudo boxTitulo="Documentos e/ou Exames Requeridos" fechado>
      <CustomRow>
        <CustomCol width="100%">
          <CustomTable
            headers={headersDocumentosMedsus}
            data={tableData}
            onRowClick={handleRowClick}
            showPagination={false}
          />
        </CustomCol>
      </CustomRow>

      {cudProdutoDaf && (
        <CustomCol style={{ marginTop: '15px', textAlign: 'right' }}>
          <CustomButton
            label="Novo Documento/Exame"
            bgColor={theme.colors.botaoAcao.azul}
            textColor={theme.colors.white}
            onClick={handleClickInserirNovo}
          />
        </CustomCol>
      )}

      {/* Modal Documento/Exame */}
      <CustomModal
        title="Documento e/ou Exame Requerido"
        open={showModalDocumento}
        onHide={handleShowModalDocumento}
        icon="description"
        width="65%"
      >
        <WorkspaceFicha>
          {updating ? <Log {...logData} entity={entity} /> : <></>}
          <BoxConteudo boxTitulo="Identificação do Documento/Exame">
            <CustomRow
              style={{
                marginTop: '-15px',
                justifyContent: 'flex-start',
              }}
            >
              <CustomCol width="200px">
                <CustomSelect
                  name="statusDocumento"
                  options={getStatusAtivoMedsusOptions()}
                  title="Status"
                  value={form.statusDocumento}
                  onChange={handleChangeDocumento}
                  required
                />
              </CustomCol>
              <CustomCol width="220px">
                {updating ? (
                  <CustomInputText
                    name="tipoDocumento"
                    title="Tipo"
                    value={TipoDocumento[Number(form.tipoDocumento) ?? 0].label}
                    onChange={handleChangeDocumento}
                    readOnly={updating}
                  />
                ) : (
                  <CustomSelect
                    name="tipoDocumento"
                    options={TipoDocumento}
                    title="Tipo"
                    value={form.tipoDocumento}
                    onChange={handleChangeDocumento}
                    required
                    disabled={updating}
                  />
                )}
              </CustomCol>
              <CustomCol width="250px">
                <CustomSelect
                  name="finalidade"
                  options={FinalidadeDocumento}
                  title="Finalidade"
                  value={form.finalidade}
                  required
                  onChange={handleChangeDocumento}
                />
              </CustomCol>
            </CustomRow>
            <CustomRow>
              {form.tipoDocumento && (
                <>
                  {Number(form.tipoDocumento) ===
                  TipoDocumentoMedsusEnum['DOCUMENTO'] ? (
                    updating ? (
                      <CustomCol>
                        <CustomInputText
                          name="subtipoDocumentoId"
                          title="Tipo de Documento"
                          value={
                            optionsSubtipoDocumento[
                              form.subtipoDocumentoId ?? 0
                            ].label
                          }
                          onChange={handleChangeDocumento}
                          type="textArea"
                          rows={3}
                          readOnly
                        />
                      </CustomCol>
                    ) : (
                      <CustomCol>
                        <SelectSearchable
                          name="subtipoDocumentoId"
                          options={optionsSubtipoDocumento}
                          label="Tipo de Documento"
                          value={
                            form.subtipoDocumento?.id ?? form.subtipoDocumentoId
                          }
                          onChange={handleChangeDocumento}
                          onCreate={handleCreateSubtipoDocumento}
                          isCreatable
                          required={
                            Number(form.tipoDocumento) ===
                            TipoDocumentoMedsusEnum['DOCUMENTO']
                          }
                          disabled={updating}
                        />
                      </CustomCol>
                    )
                  ) : Number(form.tipoDocumento) ===
                    TipoDocumentoMedsusEnum['EXAME'] ? (
                    <>
                      <CustomRow>
                        <CustomCol width="200px">
                          {updating ? (
                            <CustomInputText
                              name="subtipoExameId"
                              title="Código SISMAT"
                              value={
                                CodigoExame[form.subtipoExameId ?? 0].label
                              }
                              onChange={handleChangeDocumento}
                              readOnly
                            />
                          ) : (
                            <CustomSelectSearchable
                              name="subtipoExameId"
                              options={CodigoExame}
                              title="Código SIGTAP"
                              value={form.subtipoExameId}
                              onChange={handleChangeDocumento}
                              required={
                                Number(form.tipoDocumento) ===
                                TipoDocumentoMedsusEnum['EXAME']
                              }
                              placeholder="Selecione..."
                              disabled={updating}
                            />
                          )}
                        </CustomCol>
                      </CustomRow>
                      <CustomRow>
                        <CustomCol>
                          {updating ? (
                            <CustomInputText
                              name="subtipoExameId"
                              title="Tipo de Exame"
                              value={
                                SubtipoExame[form.subtipoExameId ?? 0].label
                              }
                              onChange={handleChangeDocumento}
                              type="textArea"
                              rows={3}
                              readOnly
                            />
                          ) : (
                            <CustomSelectSearchable
                              name="subtipoExameId"
                              options={SubtipoExame}
                              title="Tipo de Exame"
                              value={
                                form.subtipoExame?.id ?? form.subtipoExameId
                              }
                              onChange={handleChangeDocumento}
                              required={
                                Number(form.tipoDocumento) ===
                                TipoDocumentoMedsusEnum['EXAME']
                              }
                              disabled={updating}
                            />
                          )}
                        </CustomCol>
                      </CustomRow>
                    </>
                  ) : null}
                </>
              )}
            </CustomRow>
            <CustomRow>
              <CustomCol>
                <CustomInputText
                  name="detalhamento"
                  title="Detalhamento"
                  value={form.detalhamento ?? ''}
                  type="textArea"
                  rows={5}
                  onChange={handleChangeDocumento}
                />
              </CustomCol>
            </CustomRow>
            <CustomRow>
              <CustomCol>
                <CustomInputText
                  name="observacoes"
                  value={form.observacoes ?? ''}
                  title="Observações"
                  type="textArea"
                  onChange={handleChangeDocumento}
                  rows={3}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>
          <BarraInferiorBotoes>
            {updating ? (
              <WorkspaceBotoes
                delete
                deleteDisabled={!cudProdutoDaf}
                onClickDelete={handleDeleteDocumento}
                save
                saveDisabled={!cudProdutoDaf}
                onClickSave={handleUpdateDocumento}
              />
            ) : (
              <WorkspaceBotoes
                save
                saveDisabled={!cudProdutoDaf}
                onClickSave={handleCreateDocumento}
              />
            )}
          </BarraInferiorBotoes>
        </WorkspaceFicha>
      </CustomModal>
    </BoxConteudo>
  );
}
